import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/catch';
import { type Epic } from 'redux-observable';
import { of } from 'rxjs/observable/of';
import { FETCH_JIRA_PROJECT_PERMISSIONS } from '../actions';
import { setIsMember } from '../project/actions';
import { type State } from '../types';
import { type Action } from 'redux';
import { getJiraProjectPermissions$ } from './requests';
import { fetchFailed, fetchSuccess } from '../../common/fetch-request-analytics';
import { getProjectKey } from '../project/selectors';

const jiraProjectPermissions: Epic<Action, State> = (action$, store) =>
	action$.ofType(FETCH_JIRA_PROJECT_PERMISSIONS).switchMap(() => {
		const state = store.getState();
		const projectKey = getProjectKey(state);
		return getJiraProjectPermissions$(projectKey)
			.mergeMap((response) => {
				fetchSuccess('jira.permissions');
				const isMember =
					response.permissions.CREATE_ISSUES.havePermission &&
					response.permissions.EDIT_ISSUES.havePermission;
				return of(setIsMember(isMember));
			})
			.catch((err) => {
				fetchFailed('jira.permissions', err);
				// just gracefully fallback to user not being a project member if unable to fetch perms for some reason
				return of(setIsMember(false));
			});
	});

export default jiraProjectPermissions;
